<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>项目管理</a-breadcrumb-item>
      <a-breadcrumb-item>阶段管理</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="space-20">
      <a-button type="primary" @click="showModel = 'addSector'">新增</a-button>
    </div>
    <a-table :loading="loading" :columns="columns" :dataSource="list" :rowKey="row => row.id">
      <span slot="action" slot-scope="row">
        <a-button
          @click="
            currentRow = row;
            showModel = 'editSector';
          "
          size="small"
          type="primary"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-button @click="handleDeleteItem(row)" size="small" type="danger">删除</a-button>
      </span>
    </a-table>
    <a-modal title="新增阶段" @cancel="closeModel" :visible="showModel == 'addSector'" width="400px">
      <a-form>
        <a-form-item label="名称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="sectorInfo.name" placeholder="阶段名称"></a-input>
        </a-form-item>
        <a-form-item label="描述：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="sectorInfo.desc" placeholder="阶段描述"></a-input>
        </a-form-item>
        <a-form-item label="排序：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input-number :step="0.5" v-model="sectorInfo.sort" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('add')">确定</a-button>
      </template>
    </a-modal>
    <a-modal title="编辑阶段" @cancel="closeModel" :visible="showModel == 'editSector'" width="400px">
      <a-form>
        <a-form-item label="名称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.name" placeholder="阶段名称"></a-input>
        </a-form-item>
        <a-form-item label="描述：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.desc" placeholder="备注"></a-input>
        </a-form-item>
        <a-form-item label="排序：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input-number :step="0.5" v-model="currentRow.sort" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('edit')">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { stateList, stateDelete, stateAction } from '@/api/common.js';
const columns = [
  { title: '阶段名称', dataIndex: 'name' },
  { title: 'RankScore', dataIndex: 'sort', align: 'center' },
  { title: '描述', dataIndex: 'desc', align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'action' } }
];
export default {
  data() {
    return {
      loading: true,
      columns,
      list: [],
      currentRow: {},
      showModel: '',
      sectorInfo: {
        name: '',
        desc: '',
        sort: 0
      }
    };
  },
  methods: {
    closeModel() {
      this.showModel = '';
    },
    getList() {
      this.loading = true;
      stateList().then(res => {
        this.list = res.data;
        this.loading = false;
      });
    },
    handleDeleteItem(row) {
      this.$confirm({
        title: `确定删除阶段：${row.name}吗`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          stateDelete({ id: row.id }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.data);
              this.getList();
            }
          });
        }
      });
    },
    handleItem(type) {
      let data = Object.assign({}, this.sectorInfo);
      if (type === 'edit') {
        data.name = this.currentRow.name;
        data.sort = this.currentRow.sort;
        data.desc = this.currentRow.desc;
        data.id = parseInt(this.currentRow.id);
      }
      stateAction(data).then(res => {
        if (res.code === 200) {
          this.closeModel();
          this.getList();
          this.$message.success(res.data || 'success');
          !data.id && (this.sectorInfo = { name: '', desc: '', sort: 0 });
        }
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
